// extracted by mini-css-extract-plugin
module.exports = {"headline":"story-headline-module__headline__3XxvM","colored-headline":"story-headline-module__colored-headline__1ZdOp"};